export default "__VITE_ASSET__umY0YwYB__"